export const SUPPLIER_QUESTIONNAIRES = {
  TITLE: 'Questionnaires',
  UPLOAD_BUTTON: 'Upload Questionnaire',
  EMPTY_STATE: {
    TITLE: 'No questionnaires yet',
    DESCRIPTION: 'Upload your first supplier questionnaire to get started.',
  },
  FORM: {
    QUESTIONNAIRE_NAME_LABEL: 'Questionnaire Name',
    QUESTIONNAIRE_NAME_PLACEHOLDER: 'Enter a name for this questionnaire',
  },
  ACTIONS: {
    UPLOAD: 'Upload',
    UPLOAD_QUESTIONNAIRE: 'Upload Questionnaire',
    UPLOADING: 'Uploading...',
    MARK_COMPLETED: 'Mark as completed',
    DOWNLOAD_PACKAGE: 'Download evidence package',
    CANCEL: 'Cancel',
  },
  DIALOG: {
    TITLE: 'Upload Questionnaire',
    DESCRIPTION: 'Upload a questionnaire file (Excel, Word, PDF, or OpenDocument) to be processed.',
  },
  FILE_DROP_ZONE: {
    DRAG_AND_DROP: 'Drag and drop your file here, or',
    SELECT_FILE: 'Select File',
    FILE_TYPE_HINT: 'Excel, Word, PDF, or OpenDocument',
  },
  ROW: {
    PROCESSING: 'Processing...',
    QUESTIONS_SUFFIX: 'questions',
  },
  TOOLTIPS: {
    DOWNLOAD_ORIGINAL: 'Download Original',
    DOWNLOAD_RESPONSE: 'Download Response',
    PACKAGE_PREPARING: 'The evidence package is still being prepared',
    DELETE: 'Delete',
  },
  STATUS: {
    SUBMITTED: 'Submitted',
    IN_PROGRESS: 'In Progress',
    READY: 'Ready',
    COMPLETED: 'Completed',
  },
  SUMMARY: {
    QUESTIONS_LABEL: 'Questions',
    ANSWERED: 'answered',
    PENDING: 'pending',
    QUESTIONNAIRE: 'questionnaire',
    QUESTIONNAIRES: 'questionnaires',
    READY: 'ready',
    IN_PROGRESS: 'in progress',
    SUBMITTED: 'submitted',
  },
  MESSAGES: {
    UPLOAD_SUCCESS: 'Questionnaire uploaded successfully',
    DELETE_SUCCESS: 'Questionnaire deleted successfully',
    FILE_NOT_FOUND: 'This file is no longer available',
    ALREADY_COMPLETED: 'This questionnaire is completed and can no longer be changed.',
    PACKAGE_NOT_READY: "The package isn't ready yet.",
    COMPLETE_SUCCESS: 'Questionnaire marked as completed',
    CANNOT_COMPLETE: "This questionnaire can't be completed yet: its package isn't ready.",
  },
  COMPLETE_DIALOG: {
    TITLE: 'Mark questionnaire as completed?',
    BODY: '"{name}" will be marked as completed and its evidence package will become available. This can\'t be undone.',
  },
  DELETE_DIALOG: {
    TITLE: 'Delete Questionnaire',
    QUESTION: 'Are you sure you want to delete',
    WARNING: 'This action cannot be undone.',
  },
} as const
